module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/a-function.js
// module id = 52
// module chunks = 3